import protoRoot from "../proto-root";

const name = "startActivityLogRpcRequest";

function create() {
  const StartActivityLogRpcRequest = protoRoot.lookupType(
    "comm.StartActivityLogRpcRequest"
  );

  const payload = {};

  const request = StartActivityLogRpcRequest.create(payload);
  return { payload: request, name };
}

export default {
  create,
  name
};
